<header-bar title="Erfolge"></header-bar>
<div class="page-content">


  <div class="card" style="background-color: transparent!important;margin-bottom: 0; margin-top: 0;">
    <div class="content" style="margin-bottom: 6px; margin-top: 0">

      <div class="circle-container">
        <svg class="score"
             viewBox="-25 -25 400 400">
          <circle class="score-empty"
                  cx="175"
                  cy="175"
                  r="175"
                  stroke-width="25"
                  fill="none"></circle>
          <circle class="js-circle score-circle"
                  transform="rotate(-90 175 175)"
                  cx="175" cy="175" r="175"
                  stroke-dasharray="1100"
                  stroke-width="25"
                  stroke-dashoffset="1100"
                  fill="none"></circle>
          <text class="js-text score-text"
                x="50%"
                y="50%"
                dx="-25"
                text-anchor="middle"></text>
        </svg>
      </div>

      <div style="margin-top: 24px">
        <h2 class="text-center text-white">
          Du hast noch <%= remainingTime %> Zeit, um deine Erfolge zu steigern.
        </h2>
      </div>

    </div>
  </div>



</div>
<main-menu active-item="accounting"></main-menu>
